import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { Certificates } from './components/Certificates';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FreelancingPlatforms } from './components/FreelancingPlatforms';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <Portfolio data-id="element-6" />
        <Certificates data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FAQ data-id="element-9" />
        <FreelancingPlatforms data-id="element-10" />
        <Contact data-id="element-11" />
        <Footer data-id="element-12" />
      </main>
    </div>;
}